import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { StaticImageData } from 'next/image';
import { ArrowLeft, type LucideIcon } from 'lucide-react';
import { Link } from '@/i18n/navigation';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import LazyImage from '@/components/partials/lazy-image';
import NoImagePlaceholder from '@/components/partials/no-image-placeholder';
import ShareButton from '@/components/partials/share-button';
type PropsType = {
  image?: string | StaticImageData | null;
  alt: string;
  title: string;
  description?: string;
  titleExtra?: ReactNode;
  backHref?: string;
  backLabel?: string;
  shareUrl?: string;
  fallbackIcon?: LucideIcon;
  meta?: ReactNode;
  size?: 'sm' | 'md';
};
const ContentHero = t0 => {
  const $ = _c(33);
  const {
    image,
    alt,
    title,
    description,
    titleExtra,
    backHref,
    backLabel,
    shareUrl,
    fallbackIcon,
    meta,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const t2 = size === "sm" ? "h-[clamp(180px,35vw,500px)]" : "h-[clamp(220px,25vw,400px)]";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("relative w-full", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== alt || $[3] !== fallbackIcon || $[4] !== image) {
    t4 = image ? <><LazyImage src={image} alt={alt} fill={true} sizes="100vw" priority={true} className="object-cover" /><div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/40 to-black/10" /></> : <div className="flex h-full w-full items-center justify-center bg-gray-600"><NoImagePlaceholder icon={fallbackIcon} className="bg-gray-800!" /></div>;
    $[2] = alt;
    $[3] = fallbackIcon;
    $[4] = image;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== backHref || $[7] !== backLabel) {
    t5 = backHref && <div className="absolute top-4 left-4 lg:top-8 lg:left-8"><Link href={backHref}><Button variant="secondary" size="sm" className="gap-2 backdrop-blur-md"><ArrowLeft className="h-4 w-4" />{backLabel}</Button></Link></div>;
    $[6] = backHref;
    $[7] = backLabel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== shareUrl || $[10] !== title) {
    t6 = shareUrl && <div className="absolute top-4 right-4 lg:top-8 lg:right-8"><ShareButton url={shareUrl} title={title} /></div>;
    $[9] = shareUrl;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== title) {
    t7 = <h1 className="text-[clamp(1.5rem,4vw,3.75rem)] font-bold text-white drop-shadow-2xl">{title}</h1>;
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== titleExtra) {
    t8 = titleExtra && <div>{titleExtra}</div>;
    $[14] = titleExtra;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="mb-2 flex flex-wrap items-center gap-3">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== description) {
    t10 = description && <p className="text-lg text-white/90 drop-shadow-lg">{description}</p>;
    $[19] = description;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== meta) {
    t11 = meta && <div className="mt-2">{meta}</div>;
    $[21] = meta;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <div className="absolute right-4 bottom-8 left-4 lg:right-8 lg:left-8">{t9}{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6) {
    t13 = <div className={t3}>{t4}{t5}{t6}{t12}</div>;
    $[27] = t12;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
export default ContentHero;